'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Solutions(eyebrow, title, note, pillars) {
  this.i0 = null;
  this.i3 = null;
  this.i1 = null;
  this.i2 = null;
  this.i0 = eyebrow;
  this.i3 = title;
  this.i1 = note;
  this.i2 = pillars;
}
export { $c_Lio_intela_sites_intelacloud_content_Solutions as $c_Lio_intela_sites_intelacloud_content_Solutions };
$p = $c_Lio_intela_sites_intelacloud_content_Solutions.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Solutions;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Solutions() {
}
export { $h_Lio_intela_sites_intelacloud_content_Solutions as $h_Lio_intela_sites_intelacloud_content_Solutions };
$h_Lio_intela_sites_intelacloud_content_Solutions.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-964604790), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Solutions)) {
    if ((this.i0 === x$0.i0)) {
      var x = this.i3;
      var x$2 = x$0.i3;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.i1 === x$0.i1))) {
      var x$3 = this.i2;
      var x$4 = x$0.i2;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 4;
});
$p.I = (function() {
  return "Solutions";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.i0;
      break;
    }
    case 1: {
      return this.i3;
      break;
    }
    case 2: {
      return this.i1;
      break;
    }
    case 3: {
      return this.i2;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Solutions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bG)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Solutions as $isArrayOf_Lio_intela_sites_intelacloud_content_Solutions };
var $d_Lio_intela_sites_intelacloud_content_Solutions = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Solutions, "io.intela.sites.intelacloud.content.Solutions", ({
  bG: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Solutions as $d_Lio_intela_sites_intelacloud_content_Solutions };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Solutions.js.map
